import React from "react";
import { X, MapPin } from "lucide-react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };
const SERIF = { fontFamily: "'Cormorant Garamond', Georgia, serif" };

export function EditorHeader({ destination, dirty, onClose }) {
  return (
    <div
      className="flex items-center justify-between px-6 py-4 border-b border-[#DCD4C6] flex-shrink-0"
      style={{ background: "#F1EBE1", borderRadius: "3px 3px 0 0" }}
    >
      <div className="flex items-center gap-3">
        <MapPin size={16} strokeWidth={1.5} className="text-[#C17F59]" />
        <div>
          <p className="text-xs text-[#8B5E34] uppercase tracking-widest mb-0.5" style={LORA}>
            Édition itinéraire
          </p>
          <h2 className="text-2xl" style={{ ...SERIF, fontWeight: 600, color: "#2B2623" }}>
            {destination}
          </h2>
        </div>
      </div>
      <div className="flex items-center gap-3">
        {dirty && (
          <span
            className="text-xs text-amber-700 bg-amber-50 border border-amber-200 px-2 py-0.5"
            style={{ ...LORA, borderRadius: "2px" }}
          >
            Modifications non sauvegardées
          </span>
        )}
        <button
          onClick={onClose}
          className="p-1.5 text-[#9A8F86] hover:text-[#2B2623] transition-colors"
          data-testid="editor-close-btn"
        >
          <X size={18} strokeWidth={1.5} />
        </button>
      </div>
    </div>
  );
}
